function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*jshint esversion: 8 */
import { Configuration } from "../Shared/Configuration";
import { DateTimeFormatter } from "./DateTimeFormatter";
import { TextFormatter } from "./TextFormatter";
import { MapBuilder } from "./MapBuilder";
import { ReturnContext } from "../Shared/ReturnContextProvider";
export var InnerPageBuilder = /*#__PURE__*/function () {
  function InnerPageBuilder() {
    _classCallCheck(this, InnerPageBuilder);
  }

  _createClass(InnerPageBuilder, null, [{
    key: "BuildGoBack",
    value: function BuildGoBack() {
      var navLabel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Search';
      var returnUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var category = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ReturnContext.Categories.None;
      var actualReturnUrl = null;
      var returnContext = ReturnContext.Get(category);

      if (!!returnContext) {
        actualReturnUrl = returnContext.Url;
      }

      if (!actualReturnUrl) {
        actualReturnUrl = returnUrl;
      }

      return "<h3 class=\"mpp-innerpage--back\"><a href=\"".concat(actualReturnUrl, "\"><i class=\"mppw-arrow back\"></i> ").concat(navLabel, "</a></h3>");
    }
  }, {
    key: "BuildFinderDetailImage",
    value: function BuildFinderDetailImage(imageSrc, type) {
      if (imageSrc === null || imageSrc === undefined) {
        return "<div class=\"mpp-innerpage--fixed-imgcontainer mpp-innerpage--fixed-imgplaceholder\" style=\"background-image: url('".concat(new Configuration().GetAppRoot(), "/Content/icons/icon-").concat(type, ".svg')\"></div>");
      } else {
        return "<div class=\"mpp-innerpage--fixed-imgcontainer mpp-innerpage--fixed-img\" style=\"background-image: url('".concat(imageSrc, "')\"></div>");
      }
    }
  }, {
    key: "BuildImage",
    value: function BuildImage(imageSrc, type) {
      if (imageSrc === null || imageSrc === undefined) {
        return "<img class=\"mpp-innerpage--placeholder\" src=\"".concat(new Configuration().GetAppRoot(), "/Content/icons/icon-").concat(type, ".svg\" />");
      } else {
        return "<img class=\"mpp-innerpage--image\" src=\"".concat(imageSrc, "\" width=\"100%\"/>");
      }
    }
  }, {
    key: "BuildTitle",
    value: function BuildTitle(headerName) {
      return "<h1 class=\"mpp-innerpage--subtitle\">".concat(headerName, "</h1>");
    }
  }, {
    key: "BuildSubtitle",
    value: function BuildSubtitle() {
      var headerType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var headerName = arguments.length > 1 ? arguments[1] : undefined;
      return "<h".concat(headerType, " class=\"mpp-innerpage--subtitle\">").concat(headerName, "</h").concat(headerType, ">");
    }
  }, {
    key: "BuildCustomButton",
    value: function BuildCustomButton(targetUrl, btnText) {
      if (!!targetUrl) {
        return "<a href=\"".concat(targetUrl, "\" class=\"mppw-btn mpp-innerpage--button primary mb-medium\">").concat(btnText, "</a>");
      } else {
        return "";
      }
    }
  }, {
    key: "BuildDateTime",
    value: function BuildDateTime() {
      var dateTimes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var isAddToCalendar = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return "<div class=\"mpp-innerpage--datetime\">\n\t\t\t<div class=\"mpp-innerpage--datetime-wrapper\">\n\t\t\t\t".concat(dateTimes.map(function (dateTime) {
        return "<h2 class=\"mpp-innerpage--datetime ".concat(dateTime.className, "\">").concat(dateTime.text, "</h2>");
      }).join(''), "\n\t\t\t</div>\n\t\t\t").concat(isAddToCalendar ? "".concat(this.BuildButton({
        type: 'primary',
        text: 'Add to Calendar'
      })) : '', "\n\t\t</div>");
    }
  }, {
    key: "BuildGroupDateTime",
    value: function BuildGroupDateTime(meetingFrequency, meetingDay, meetingTime) {
      return "<div class=\"mpp-innerpage--datetime\">\n\t\t\t<div class=\"mpp-innerpage--datetime-wrapper\">\n\t\t\t\t<h2 class=\"mpp-innerpage--datetime\">".concat(!!meetingFrequency ? "".concat(meetingFrequency, " on") : '', " ").concat(!!meetingDay ? meetingDay : '', " ").concat(!!meetingTime && !!meetingDay ? "@ ".concat(new DateTimeFormatter().ToShortTime(meetingTime)) : '', "</h2>\n\t\t\t</div>\n\t\t</div>");
    }
  }, {
    key: "BuildEventDateTime",
    value: function BuildEventDateTime(meetingDay, meetingTime, location) {
      var isAddToCalendar = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      return "<div class=\"mpp-innerpage--datetime\">\n\t\t\t<div class=\"mpp-innerpage--datetime-wrapper\">\n\t\t\t\t<h2 class=\"mpp-innerpage--datetime\">".concat(meetingDay, " @ ").concat(new DateTimeFormatter().ToShortTime(meetingTime), "</h2>\n\t\t\t\t").concat(location === null ? '' : "<h2 class=\"mpp-innerpage--datetime\">".concat(location, "</h2>"), "\n\t\t\t</div>\n\t\t\t").concat(isAddToCalendar ? "".concat(this.BuildButton({
        type: 'primary',
        text: 'Add to Calendar'
      })) : '', "\n\t\t</div>");
    }
  }, {
    key: "BuildOpportunityDateTime",
    value: function BuildOpportunityDateTime(startDate, meetingDay) {
      return "<div class=\"mpp-innerpage--datetime\">\n\t\t\t<div class=\"mpp-innerpage--datetime-wrapper\">\n\t\t\t\t<h2 class=\"mpp-innerpage--datetime\">".concat(startDate === null ? meetingDay : new DateTimeFormatter().ToShortDateTime(startDate), "</h2>\n\t\t\t</div>\n\t\t</div>");
    }
  }, {
    key: "BuildDescription",
    value: function BuildDescription() {
      var description = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (description === null || description === undefined) {
        return;
      }

      return "<p class=\"mpp-innerpage--description\">\n\t\t\t".concat(new TextFormatter(description).addLineBreaks(), "\n\t\t</p>");
    }
  }, {
    key: "BuildSpecialText",
    value: function BuildSpecialText() {
      var special = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var regular = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var counterText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

      if (regular === null || regular === undefined || regular === 'undefined') {
        return;
      }

      if (special === '' || special === null) {
        return "<div class=\"mpp-innerpage--special\"><div class=\"mpp-innerpage--special-content\">".concat(new TextFormatter(regular).addLineBreaks(), " ").concat(new TextFormatter(counterText).addLineBreaks(), "</div></div>");
      } else {
        return "<div class=\"mpp-innerpage--special\"><div class=\"mpp-innerpage--special-title\">".concat(special, "</div><div class=\"mpp-innerpage--special-content\">").concat(new TextFormatter(regular).addLineBreaks(), " ").concat(new TextFormatter(counterText).addLineBreaks(), "</div></div>");
      }
    }
  }, {
    key: "BuildCapacityText",
    value: function BuildCapacityText() {
      var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      if (label === null || label === undefined || label === 'undefined') {
        return;
      }

      if (title === '' || title === null) {
        return "<div class=\"mpp-innerpage--capacity\"><div class=\"mpp-innerpage--capacity-content\">".concat(label, "</div></div>");
      } else {
        return "<div class=\"mpp-innerpage--capacity\"><div class=\"mpp-innerpage--capacity-title\">".concat(title, "</div><div class=\"mpp-innerpage--capacity-content\">").concat(label, "</div></div>");
      }
    }
  }, {
    key: "BuildAddress",
    value: function BuildAddress() {
      var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Primary Address";
      return "<div class=\"mpp-innerpage--address-container\">\n\t\t\t<strong class=\"mpp-innerpage--address-label\">".concat(label, ":</strong>\n\t\t\t<ul class=\"mpp-innerpage--address\">\n\t\t\t\t").concat(address.filter(function (el) {
        return el !== null;
      }).map(function (line) {
        return "<li class=\"mpp-innerpage--address-line\">".concat(line, "</li>");
      }).join(''), "\n\t\t\t</ul>\n\t\t</div>");
    }
  }, {
    key: "BuildButton",
    value: function BuildButton(_ref) {
      var type = _ref.type,
          text = _ref.text;
      return "<button class=\"mpp-innerpage--button ".concat(type, "\">").concat(text, "</button>");
    } // Shows or hides the element(s) passed in
    // Example: this.DisplayElements(true, this._$formContainer, this._$pageLoadingContainer);

  }, {
    key: "DisplayElements",
    value: function DisplayElements() {
      var display = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      for (var _len = arguments.length, elements = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        elements[_key - 1] = arguments[_key];
      }

      for (var _i = 0, _elements = elements; _i < _elements.length; _i++) {
        var element = _elements[_i];

        if (element) {
          // Get all inputs for the given div
          var inputElements = element.getElementsByTagName("input");

          if (display === true) {
            // Display div
            element.style.display = "block"; // Remove the disabled attribute that was set below

            var _iterator = _createForOfIteratorHelper(inputElements),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var el = _step.value;
                el.removeAttribute("disabled");
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          } else {
            // Hide div
            element.style.display = "none"; // Add disabled to prevent form validation issues on hidden inputs

            var _iterator2 = _createForOfIteratorHelper(inputElements),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var _el = _step2.value;

                _el.setAttribute("disabled", true);
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
        }
      }
    }
  }, {
    key: "BuildLabels",
    value: function BuildLabels(labels, i18n) {
      labels = labels || [];
      labels = labels.filter(function (i) {
        return i;
      });
      return "<ul class=\"mpp-innerpage--labels\">\n\t\t\t".concat(labels.map(function (label) {
        return "<li class=\"mpp-innerpage--label\">".concat(InnerPageBuilder.ApplyI18n(i18n, label), "</li>");
      }).join(''), "\n\t\t</ul>");
    }
    /**
     * Method looks for i18n translation if label text starts with i18n_
     * @param {Array} i18n Array of label translations
     * @param {String} label Current label
     */

  }, {
    key: "ApplyI18n",
    value: function ApplyI18n(i18n, label) {
      var result = label;

      if (!!label && !!label.indexOf && label.indexOf("i18n_") == 0) {
        label = label.substring(5);
        result = i18n[label];
      }

      return result;
    }
  }, {
    key: "old_BuildMap",
    value: function old_BuildMap() {
      var labels = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['8381 Katella Ave', 'Stanton, CA 90680'];
      var address = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3315.3649250590233!2d-117.9861483308044!3d33.80289458458454!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80dd291d79475c01%3A0x6526723d8f95e53c!2s8381+Katella+Ave%2C+Stanton%2C+CA+90680!5e0!3m2!1sen!2sus!4v1537121370163";
      // latitude and longitude as params
      return "<div class=\"mpp-innerpage--map\">\n\t\t\t<iframe src=\"".concat(address, "\" frameborder=\"0\" style=\"border:0\" allowfullscreen=\"\"></iframe>\n\t\t\t<div class=\"mpp-innerpage--map-info\">\n\t\t\t\t").concat(labels.map(function (label) {
        return "<p>".concat(label, "</p>");
      }).join(''), "\n\t\t\t\t<strong><a href=\"#\">Get Directions</a></strong>\n\t\t\t</div>\n\t\t</div>");
    }
  }, {
    key: "BuildMap",
    value: function BuildMap(address) {
      var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Get Directions";
      // latitude and longitude as params
      // if latitude and longitude doesn't exist
      // directions show place
      return "<div class=\"mpp-innerpage--map\">\n\t\t\t<div id=\"map\" style=\"width: 300px; height: 300px; border: solid 2px blue;\"></div>\n\t\t\t<div class=\"mpp-innerpage--map-info\">\n\t\t\t\t<strong><a href=\"https://www.google.com/maps/place/".concat(address, "/\" target=\"_blank\">").concat(text, "</a></strong>\n\t\t\t</div>\n\t\t</div>");
    }
  }, {
    key: "BuildGoogleMap",
    value: function BuildGoogleMap($mapEl, latitude, longitude, address, title) {
      var addressData = {
        lat: latitude,
        lng: longitude,
        address: address,
        title: title,
        zoom: 10
      };
      MapBuilder.DrawMap($mapEl, addressData);
    }
  }, {
    key: "BuildMapAddress",
    value: function BuildMapAddress(address) {
      var showAddressLabel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var text = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "Get Directions";

      if (address === null || address === undefined) {
        return '';
      } else {
        if (showAddressLabel === true) {
          return "<p>".concat(address, "</p>\n\t\t\t\t<strong><a href=\"").concat(this.MapsSelector(address), "\" target=\"_blank\">").concat(text, " ></a></strong>");
        } else {
          return "<strong><a href=\"".concat(this.MapsSelector(address), "\" target=\"_blank\">").concat(text, " ></a></strong>");
        }
      }
    }
  }, {
    key: "MapsSelector",
    value: function MapsSelector(address) {
      if (
      /* if we're on iOS, open in Apple Maps */
      navigator.platform.indexOf("iPhone") != -1 || navigator.platform.indexOf("iPod") != -1 || navigator.platform.indexOf("iPad") != -1) {
        var iOSMapAddress = "maps://maps.google.com/maps?daddr=".concat(address, "&amp;ll=");
        return iOSMapAddress;
      } else {
        /* else use Google */
        var mapAddress = "https://maps.google.com/maps?daddr=".concat(address, "&amp;ll=");
        return mapAddress;
      }
    }
  }, {
    key: "BuildProgress",
    value: function BuildProgress() {
      var header = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '$750 of $1,000 Goal (75%)';
      var percentage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '75';
      var description = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '12 installments beginning 05/15/2019';
      return "<div class=\"progress--container\">\n\t\t\t<h3>Progress:</h3>\n\t\t\t<h3 class=\"progress--subtitle\">".concat(header, "</h3>\n\t\t\t<svg class=\"mpp-card--progress\" width=\"100%\" height=\"15\">\n\t\t\t\t<defs>\n\t\t\t\t\t<linearGradient id=\"gradient\">\n\t\t\t\t\t\t<stop offset=\"0%\" stop-color=\"#1b88b0\" />\n\t\t\t\t\t\t<stop offset=\"100%\" stop-color=\"#1fb5ac\" />\n\t\t\t\t\t</linearGradient>\n\t\t\t\t</defs>\n\t\t\t\t<g>\n\t\t\t\t\t<rect fill=\"#efefef\" width=\"100%\" height=\"15\"></rect>\n\t\t\t\t\t<rect fill=\"url(#gradient)\" width=\"").concat(percentage, "%\" height=\"15\"></rect>\n\t\t\t\t</g>\n\t\t\t</svg>\n\t\t\t<p class=\"mpp-card--description\">").concat(description, "</p>\n\t\t</div>");
    }
  }, {
    key: "BuildContacts",
    value: function BuildContacts() {
      var contacts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var headerName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Contact(s)";
      var allowEmail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (contacts === undefined || contacts === null) {
        return;
      }

      return "<div class=\"mpp-innerpage--contacts-wrapper mpp-innerpage--special\">\n\t\t\t<div class=\"mpp-innerpage--special-title\">".concat(headerName, ":</div>\n\t\t\t<ul class=\"mpp-innerpage--contacts mpp-innerpage--special-content\">\n\t\t\t\t").concat(contacts && contacts.map(function (contact) {
        var hasEmailAddress = contact.emailAddress && contact.emailAddress !== '';
        var displayName = contact.displayName,
            imageUrl = contact.imageUrl,
            contactId = contact.contactId;
        displayName = displayName.replace(' ', '<br>');
        return "<li class=\"mpp-innerpage--contact ".concat(allowEmail && hasEmailAddress ? 'mpp-innerpage--contact-has-email' : '', "\" data-id=\"").concat(contactId, "\">\n\t\t\t\t\t\t\t<span class=\"mpp-innerpage--contact-badge\" ").concat(imageUrl ? "style=\"background: center / cover url('".concat(imageUrl, "?$thumbnail=true') no-repeat transparent\">") : ">".concat(displayName.charAt(0)), "</span>\n\t\t\t\t\t\t\t<span class=\"mpp-innerpage--name ").concat(allowEmail && hasEmailAddress ? 'mpp-innerpage--name-has-email' : '', "\">").concat(displayName, "</span>\n\t\t\t\t\t\t</li>");
      }).join(''), "\n\t\t\t</ul>\n\t\t</div>");
    }
  }, {
    key: "BuildPageMetadata",
    value: function BuildPageMetadata(title) {
      var dateTimes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var description = arguments.length > 2 ? arguments[2] : undefined;
      var meetingInstructions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
      return "\n\t\t<div class=\"mppw-row\">\n\t\t\t<div class=\"mppw-col\">\n\t\t\t\t<label><strong>Title</strong></label>\n\t\t\t\t<p>".concat(title, "</p>\n\t\t\t</div>\n\t\t\t <div class=\"mppw-col\">\n\t\t\t\t<label><strong>Meeting Instructions</strong></label>\n\t\t\t\t<p>").concat(meetingInstructions, "</p>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"mppw-row\">\n\t\t\t<div class=\"mppw-col\">\n\t\t\t\t<label><strong>Date</strong></label>\n\t\t\t\t<p>").concat(dateTimes.map(function (dateTime) {
        return "".concat(dateTime);
      }).join(''), "</p>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"mppw-row\">\n\t\t\t\t<label><strong>Description</strong></label>\n\t\t\t\t<p>").concat(description, "</p>\n\t\t</div>");
    }
  }, {
    key: "BuildInnerPageDetails",
    value: function BuildInnerPageDetails() {
      for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        params[_key2] = arguments[_key2];
      }

      params = params.filter(Boolean);
      return "<section class=\"mpp-innerpage\">\n\t\t\t".concat(params.map(function (param) {
        return "".concat(param);
      }).join(''), "\n\t\t</section>");
    } // Adds tab click event handling

  }, {
    key: "BindTabEventListeners",
    value: function BindTabEventListeners(tabElements, root) {
      var _this = this;

      // Add click event listener to each element
      for (var i = 0; i < tabElements.length; i++) {
        tabElements[i].addEventListener("click", function (e) {
          e.preventDefault(); // Add active class to the currently selected tab

          var clickedTab = e.currentTarget;

          _this.SetActiveTab(tabElements, clickedTab.id, root);
        });
      }
    } // Set specific tab element id as active

  }, {
    key: "SetActiveTab",
    value: function SetActiveTab(tabElements, activeTabId, root) {
      // Remove active class from tabs
      for (var y = 0; y < tabElements.length; y++) {
        tabElements[y].classList.remove("active");
      } // Add active class to the currently selected tab


      var activeTabElement = root.querySelector("#".concat(activeTabId));
      activeTabElement.classList.add("active"); // Remove active class from all content areas

      var tabContentAreas = root.querySelectorAll(".mpp-form--tab-content");

      for (var j = 0; j < tabContentAreas.length; j++) {
        tabContentAreas[j].classList.remove("active");
      } // Add active class to the currently selected content area


      var activeContentArea = root.querySelector(".".concat(activeTabId));
      activeContentArea.classList.add("active");
    } // Hide all tabs in tabsToHideArray which is an array of html element id's

  }, {
    key: "HideTabs",
    value: function HideTabs(tabElements, tabsToHideArray, root) {
      var _this2 = this;

      // Remove hidden class from tabs
      for (var y = 0; y < tabElements.length; y++) {
        tabElements[y].classList.remove("hide-tab");
      } // Remove hidden class from all content areas


      var tabContentAreas = root.querySelectorAll(".mpp-form--tab-content");

      for (var j = 0; j < tabContentAreas.length; j++) {
        tabContentAreas[j].classList.remove("hide-tab");
      } // Hide specific tabs


      if (!!tabsToHideArray) {
        tabsToHideArray.forEach(function (element) {
          _this2.SetTabVisibile(element, false, root);
        });
      }
    } // Set specific html element tab id visibility

  }, {
    key: "SetTabVisibile",
    value: function SetTabVisibile(visibleTabId, visible, root) {
      var toggleTabElement = root.querySelector("#".concat(visibleTabId));
      var toggleTabContentArea = root.querySelector(".".concat(visibleTabId));
      visible === true ? toggleTabElement.classList.remove("hide-tab") : toggleTabElement.classList.add("hide-tab");
      visible === true ? toggleTabContentArea.classList.remove("hide-tab") : toggleTabContentArea.classList.add("hide-tab");
    }
  }]);

  return InnerPageBuilder;
}();